import { render, staticRenderFns } from "./Redessociales.vue?vue&type=template&id=66f3a04c&"
import script from "./Redessociales.js?vue&type=script&lang=js&"
export * from "./Redessociales.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports